import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { buildPromptPopupStylesheet } from "./VariantPromptPopupStyleResolver";
library.add(fab, fas, far);

const SPARKLE_SVG = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.23492 2.93404C7.24594 2.93404 8.06869 3.75728 8.06869 4.76781C8.06869 4.97026 8.233 5.13456 8.43545 5.13456C8.6379 5.13456 8.8022 4.97026 8.8022 4.76781C8.8022 3.75728 9.62544 2.93404 10.636 2.93404C10.8384 2.93404 11.0027 2.76973 11.0027 2.56728C11.0027 2.36532 10.8384 2.20053 10.636 2.20053C9.62544 2.20053 8.8022 1.37826 8.8022 0.366755C8.8022 0.164795 8.6379 0 8.43545 0C8.233 0 8.06869 0.164795 8.06869 0.366755C8.06869 1.37826 7.24594 2.20053 6.23492 2.20053C6.03247 2.20053 5.86816 2.36532 5.86816 2.56728C5.86816 2.76973 6.03247 2.93404 6.23492 2.93404Z"
      fill="white"
    />
    <path
      d="M1.10026 7.33505C1.30271 7.33505 1.46702 7.17074 1.46702 6.96829C1.46702 6.76634 1.63132 6.60154 1.83377 6.60154C2.03622 6.60154 2.20053 6.43723 2.20053 6.23479C2.20053 6.03283 2.03622 5.86803 1.83377 5.86803C1.63132 5.86803 1.46702 5.70372 1.46702 5.50128C1.46702 5.29932 1.30271 5.13452 1.10026 5.13452C0.897815 5.13452 0.733509 5.29932 0.733509 5.50128C0.733509 5.70372 0.569203 5.86803 0.366755 5.86803C0.164306 5.86803 0 6.03283 0 6.23479C0 6.43723 0.164306 6.60154 0.366755 6.60154C0.569203 6.60154 0.733509 6.76634 0.733509 6.96829C0.733509 7.17074 0.897815 7.33505 1.10026 7.33505Z"
      fill="white"
    />
    <path
      d="M13.311 11.6918L5.54627 3.92711C5.33844 3.71928 5.06289 3.60583 4.76777 3.60583C4.47265 3.60583 4.1971 3.72051 3.98927 3.92711L3.55944 4.35695C3.3521 4.56478 3.23865 4.84082 3.23865 5.13496C3.23865 5.43007 3.35283 5.70612 3.55944 5.91345L11.3244 13.6784C11.5322 13.8867 11.8077 14.0001 12.1029 14.0001C12.398 14.0001 12.6735 13.8855 12.8814 13.6784L13.3112 13.2485C13.5185 13.0412 13.6325 12.7652 13.6325 12.47C13.6325 12.1757 13.5178 11.8996 13.311 11.6918Z"
      fill="white"
    />
    <path
      d="M1.10028 2.20053C1.70664 2.20053 2.20054 2.69467 2.20054 3.30079C2.20054 3.50324 2.36485 3.66755 2.56729 3.66755C2.76974 3.66755 2.93405 3.50324 2.93405 3.30079C2.93405 2.69467 3.42794 2.20053 4.03431 2.20053C4.23676 2.20053 4.40107 2.03622 4.40107 1.83377C4.40107 1.63181 4.23676 1.46702 4.03431 1.46702C3.42794 1.46702 2.93405 0.973122 2.93405 0.366755C2.93405 0.164795 2.76974 0 2.56729 0C2.36485 0 2.20054 0.164795 2.20054 0.366755C2.20054 0.973122 1.70664 1.46702 1.10028 1.46702C0.897827 1.46702 0.733521 1.63181 0.733521 1.83377C0.733521 2.03622 0.897827 2.20053 1.10028 2.20053Z"
      fill="white"
    />
    <path
      d="M4.03431 8.80198C3.42794 8.80198 2.93405 8.30808 2.93405 7.70172C2.93405 7.49976 2.76974 7.33496 2.56729 7.33496C2.36485 7.33496 2.20054 7.49976 2.20054 7.70172C2.20054 8.30808 1.70664 8.80198 1.10028 8.80198C0.897827 8.80198 0.733521 8.96677 0.733521 9.16873C0.733521 9.37118 0.897827 9.53549 1.10028 9.53549C1.70664 9.53549 2.20054 10.0296 2.20054 10.6358C2.20054 10.8382 2.36485 11.0025 2.56729 11.0025C2.76974 11.0025 2.93405 10.8382 2.93405 10.6358C2.93405 10.0296 3.42794 9.53549 4.03431 9.53549C4.23676 9.53549 4.40107 9.37118 4.40107 9.16873C4.40107 8.96677 4.23676 8.80198 4.03431 8.80198Z"
      fill="white"
    />
  </svg>
);

const VariantPromptPopup = (props) => {
  const variant = props.variant;
  const messages = props.messages || [];
  const previewState = props.previewState || "expanded";

  const previewText =
    messages.length > 0 && messages[0].text
      ? messages[0].text
      : "Not sure where to start?";

  const buttonColor = variant.options["prompt-button-color"] || "#0D42E4";
  const buttonIcon = variant.options["prompt-icon"] ? (
    <FontAwesomeIcon icon={variant.options["prompt-icon"]} />
  ) : (
    SPARKLE_SVG
  );
  const stylesheet = buildPromptPopupStylesheet(
    props.builder,
    props.device,
    props.cta,
    variant
  );

  if (previewState === "collapsed") {
    return (
      <React.Fragment>
        <div
          className="cf-prompt-btn cf-prompt-btn-standalone"
          style={{ background: buttonColor }}
        >
          {buttonIcon}
        </div>
        <style dangerouslySetInnerHTML={{ __html: stylesheet }} />
      </React.Fragment>
    );
  }

  const pillStyle =
    previewState === "triggering"
      ? {
          animation:
            "cf-prompt-slide-up 0.7s cubic-bezier(0.34,1.56,0.64,1) forwards",
        }
      : undefined;

  return (
    <React.Fragment>
      <div className="cf-prompt-pill" style={pillStyle}>
        <p className="cf-prompt-typewriter">{previewText}</p>
        <div className="cf-prompt-btn" style={{ background: buttonColor }}>
          {buttonIcon}
        </div>
      </div>
      <style dangerouslySetInnerHTML={{ __html: stylesheet }} />
    </React.Fragment>
  );
};

VariantPromptPopup.propTypes = {
  variant: PropTypes.object.isRequired,
  cta: PropTypes.object.isRequired,
  website: PropTypes.object,
  user: PropTypes.object,
  builder: PropTypes.bool,
  device: PropTypes.string,
  messages: PropTypes.array,
  previewState: PropTypes.oneOf(["triggering", "expanded", "collapsed"]),
};

export default VariantPromptPopup;
